// extracted by mini-css-extract-plugin
export default {"column":"styles__column--EjFje","row":"styles__row--GHMWZ","left":"styles__left--aE3c5","main":"styles__main--Z2MaH"};